module.exports = __webpack_public_path__ + "static/media/whitelogo.24f7fa11.png";